/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Toast_GeneratedInputs */

const en_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question bank generated`)
};

const de_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragenbank generiert`)
};

const fr_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banque de questions générée`)
};

const es_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banco de preguntas generado`)
};

const it_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banca delle domande generata`)
};

const nl_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vragenbank gegenereerd`)
};

const pl_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bank pytań wygenerowany`)
};

const fi_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kysymyspankki luotu`)
};

const da_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spørgsmålsbank genereret`)
};

const sv_interview_qbank_toast_generated = /** @type {(inputs: Interview_Qbank_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frågebank genererad`)
};

/**
* | output |
* | --- |
* | "Question bank generated" |
*
* @param {Interview_Qbank_Toast_GeneratedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_toast_generated = /** @type {((inputs?: Interview_Qbank_Toast_GeneratedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Toast_GeneratedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_toast_generated(inputs)
	if (locale === "fr") return fr_interview_qbank_toast_generated(inputs)
	if (locale === "es") return es_interview_qbank_toast_generated(inputs)
	if (locale === "it") return it_interview_qbank_toast_generated(inputs)
	if (locale === "nl") return nl_interview_qbank_toast_generated(inputs)
	if (locale === "pl") return pl_interview_qbank_toast_generated(inputs)
	if (locale === "fi") return fi_interview_qbank_toast_generated(inputs)
	if (locale === "da") return da_interview_qbank_toast_generated(inputs)
	if (locale === "sv") return sv_interview_qbank_toast_generated(inputs)
	return en_interview_qbank_toast_generated(inputs)
});